export const environment = {
    production: false,
    keycloak: {
        url: 'https://auth-dev.baywa-lusy.com',
        realm: 'master',
        clientId: 'cpe-frontend',
        redirect: 'https://cpe-staging.baywa-lusy.com',
        appendBearerTokenTo: [
            'https://api-staging.baywa-lusy.com'
        ]
    },
    cpe: {
        url: 'https://api-staging.baywa-lusy.com/cpe'
    }
};
